import React from 'react';
import { Link } from 'react-router-dom';

const CheckContactEmail = ({ title, buttonId, buttonText, buttonLink, children }) => {

    return (
        <div className="w-full max-w-450px m-auto">
            <div className="bg-white w-full rounded-2xl">
                <div className="p-40px sm:p-60px">
                    <h2 className="text-everflow-magenta font-bold text-center">{title}</h2>
                    <p className="mt-32px text-everflow-black text-center">{children}</p>
                    <div className="bg-everflow-green-success-10 border-everflow-green-success-dashed rounded-2xl mt-30px p-32px max-w-600px max-w-full mx-auto" >
                        <p className="text-everflow-black text-center">
                            If you haven't received an email from us within 30 minutes,
                            <br />
                            please check the details you entered and try again.
                        </p>
                    </div>
                </div>
                {buttonLink ? (
                    <div className="p-32px text-center border-t-2 border-gray-default-500">
                        <div>
                            <Link id={buttonId} className="underline text-everflow-black" to={buttonLink}>{buttonText}</Link>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default CheckContactEmail;